import { useState } from 'react';

type TypeUseModalProps<TOnOpen, TOnConfirm, TOnClose> = {
  defaultOpen?: boolean;
  onOpen?: (data?: TOnOpen) => void | Promise<void>;
  onOpenCompleted?: () => void | Promise<void>;
  onConfirm?: (data?: TOnConfirm) => void | Promise<void>;
  onConfirmCompleted?: () => void | Promise<void>;
  onClose?: (data?: TOnClose) => void | Promise<void>;
  onCloseCompleted?: () => void | Promise<void>;
};

const useModal = <TOnOpen, TOnConfirm, TOnClose>({
  defaultOpen = false,
  onOpen,
  onOpenCompleted,
  onClose,
  onCloseCompleted,
  onConfirm,
  onConfirmCompleted,
}: TypeUseModalProps<TOnOpen, TOnConfirm, TOnClose> = {}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const handleOpenModal = async (data?: TOnOpen) => {
    await onOpen?.(data);

    setIsOpen(true);

    await onOpenCompleted?.();
  };

  const handleConfirmModal = async (data?: TOnConfirm) => {
    await onConfirm?.(data);

    setIsOpen(false);

    await onConfirmCompleted?.();
  };

  const handleCloseModal = async (data?: TOnClose) => {
    await onClose?.(data);

    setIsOpen(false);

    await onCloseCompleted?.();
  };

  return { isOpen, handleOpenModal, handleCloseModal, handleConfirmModal };
};

export default useModal;
